const SAFE_URL_PATTERN = /^(?:https?:|mailto:|tel:)|^[#/][^:]*$|^[^:]+$/;

export function isAllowedMarkdownHref(href: string): boolean {
  const u = href.trim();
  if (!u || u.length > 16384) return false;
  if (u.startsWith('mailto:') || u.startsWith('tel:') || u.startsWith('#')) return true;
  if (u.startsWith('/') && !u.startsWith('//')) return true;
  if (/^https?:\/\//i.test(u)) {
    try {
      const parsed = new URL(u);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  }
  return SAFE_URL_PATTERN.test(href);
}
